/** Media delivery only. Keep the original S3 URLs in saved records. */
export function getMediaDeliveryBaseUrl(): string {
  const configured = process.env.NEXT_PUBLIC_MEDIA_ASSET_BASE_URL?.trim();
  if (!configured) {
    throw new Error("NEXT_PUBLIC_MEDIA_ASSET_BASE_URL is required for media delivery.");
  }
  const url = new URL(configured);
  if (url.protocol !== "https:" || url.username || url.password || url.port ||
      url.pathname !== "/" || url.search || url.hash) {
    throw new Error("NEXT_PUBLIC_MEDIA_ASSET_BASE_URL must be an HTTPS origin URL.");
  }
  return url.origin;
}

const mediaBucket = "reelmagic-v2-media";
const renderBucket = "remotionlambda-useast1-53nasxtmet";
const s3Hostnames = new Map<string, string>([
  ...[mediaBucket, renderBucket].flatMap((bucket) => [
    [`${bucket}.s3.us-east-1.amazonaws.com`, bucket],
    [`${bucket}.s3.amazonaws.com`, bucket],
    [`${bucket}.s3-us-east-1.amazonaws.com`, bucket],
  ] as const),
]);

export function resolveMediaDeliveryUrl<T extends string | null | undefined>(value: T): T {
  if (!value || !value.startsWith("https://")) return value;
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return value;
  }
  if (url.username || url.password || url.port || url.searchParams.has("X-Amz-Signature")) {
    return value;
  }
  let bucket = s3Hostnames.get(url.hostname);
  let path = url.pathname;
  if (url.hostname === "s3.us-east-1.amazonaws.com" || url.hostname === "s3.amazonaws.com") {
    const separator = path.indexOf("/", 1);
    bucket = path.slice(1, separator);
    path = path.slice(separator);
  }
  const supported = bucket === mediaBucket
    ? path.startsWith("/assets/") || path.startsWith("/users/")
    : bucket === renderBucket && path.startsWith("/renders/");
  if (!supported) return value;
  return `${getMediaDeliveryBaseUrl()}${path}${url.search}${url.hash}` as T;
}
